import { ImageMetadataModel } from './image-metadata.model';
import { ImageApiModel } from '../../../api/mentions/model/image.api.model';
import { basicClone, Clonable } from '../../Basic/decorators/clone.decorator';

export class ImageModel {
    @Clonable()
    source: string;
    @Clonable()
    description?: string;
    @Clonable()
    metadata?: ImageMetadataModel;
    @Clonable()
    error?: boolean;
    @Clonable()
    name?: string;
    @Clonable()
    isPreferred?: boolean;

    constructor(apiEntity?: ImageApiModel) {
        const hasApiEntity: boolean = apiEntity !== null && apiEntity !== undefined;

        if (hasApiEntity) {
            this.constructFromApiEntity(apiEntity);
        } else {
            this.constructDefault();
        }
    }

    /**
     * Constructs this model based on either an image URL or a full API entity
    */
    private constructFromApiEntity(apiEntity: ImageApiModel): void {
        this.source = apiEntity.url;
        this.description = null;
        this.metadata = new ImageMetadataModel(apiEntity.metadata);
        this.error = false;
        if (apiEntity.isPreferred !== undefined || apiEntity.isPreferred !== null) {
            this.isPreferred = apiEntity.isPreferred;
        }
    }

    /**
     * Constructs the default version of this model
    */
    private constructDefault(): void {
        this.source = null;
        this.description = null;
        this.metadata = new ImageMetadataModel();
        this.error = false;
    }

    public toApiEntity(): ImageApiModel {
        const apiModel: ImageApiModel = {
            url: this.source,
            metadata: this.metadata.toApiEntity(),
        };

        if (this.isPreferred !== undefined || this.isPreferred !== null) {
            apiModel.isPreferred = this.isPreferred;
        }

        return apiModel;
    }

    public clone(): ImageModel {
        return basicClone(this);
    }
}
